import axiosInstance from "./api_helper";

export const createReceiptNote = async (receiptNote) => {
  try {
    const response = await axiosInstance.post('/api/receipt-notes', JSON.stringify(receiptNote));
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateReceiptNote = async (id, receiptNote) => {
  try {
    const response = await axiosInstance.put(`/api/receipt-notes/${id}`, JSON.stringify(receiptNote));
    return response;
  } catch (error) {
    throw error;
  }
};

export const annulerBR = async (id) => {
  return axiosInstance.delete(`/api/receipt-notes/annuler/${id}`);
};

export const resetBR = async (id) => {
  return axiosInstance.put(`/api/receipt-notes/reset/${id}`);
};

export const search = async ({ fournisseurId, dateFrom, dateTo, sansFacture, query }) => {
  const params = {};
  if (fournisseurId !== undefined && fournisseurId !== null) params.fournisseurId = fournisseurId;
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  if (sansFacture) params.sansFacture = sansFacture;
  if (query) params.query = query;

  const response = await axiosInstance.get('/api/receipt-notes/search', { params });

  return response;
};

export const getNewBRNumber = async () => {
  return axiosInstance.get(`/api/receipt-notes/new-br-number`);
};


export const validateReceiptNote = async (id) => {
  return axiosInstance.put(`/api/receipt-notes/${id}/valider`);
};

export const generateDocument = async (id) => {
  const response = await axiosInstance.get(`/api/receipt-notes/report/${id}`, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export const getReceiptNotesByPurchaseId = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/receipt-notes/bon-commande/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const generatePdf = async (invoiceDTO) => {
  const response = await axiosInstance.post(`/api/receipt-notes/report`, invoiceDTO, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};